/**
 * The game's Ember models come from its content (`content/game/sprites/ember/`, compiled into the
 * catalog) and follow it when a release is activated live: the body layer (bodies.json, hair.json)
 * under the equipment (equipment.json). The tables they draw with -- palettes, styles, marks and
 * eyes, humanoids -- are bound by the modules that own them (palette.ts, styles.ts, marks.ts,
 * face.ts, humanoids.ts).
 */
import { bindContent } from "../content/catalog"
import { registerEmberBodies, registerEmberModels } from "./model"

bindContent(catalog => ({ bodies: (catalog.source as any).emberBodies, hair: (catalog.source as any).emberHair }), ({ bodies, hair }) => registerEmberBodies(bodies, hair))
bindContent(catalog => (catalog.source as any).ember, registerEmberModels)
